import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_budget_allocation_main_details: { message: "idle" },
};

export const retrieve_budget_allocation_main_details_Slice = createSlice({
 name: "retrieve_budget_allocation_main_details",
 initialState,
 reducers: {
  success_retrieve_budget_allocation_main_details: (state, action) => {
   state.retrieve_budget_allocation_main_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_budget_allocation_main_details: (state, action) => {
   state.retrieve_budget_allocation_main_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_budget_allocation_main_details: (state) => {
   state.retrieve_budget_allocation_main_details = { status: app_consts.IDLE };
  },
  loading_retrieve_budget_allocation_main_details: (state) => {
   state.retrieve_budget_allocation_main_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_budget_allocation_main_details, fail_retrieve_budget_allocation_main_details, reset_retrieve_budget_allocation_main_details, loading_retrieve_budget_allocation_main_details } = retrieve_budget_allocation_main_details_Slice.actions;

export default retrieve_budget_allocation_main_details_Slice.reducer;